import React from 'react';
import { NavLink } from 'react-router-dom';
import './MobileBottomNav.css';

export default function MobileBottomNav() {
    return (
        <nav className="mobile-bottom-nav">
            <NavLink
                to="/artisan/dashboard"
                className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
            >
                <div className="icon">📅</div>
                <span>Schedule</span>
            </NavLink>

            <NavLink
                to="/artisan/requests"
                className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
            >
                <div className="icon">🔔</div>
                <span>Requests</span>
            </NavLink>

            <NavLink
                to="/artisan/profile"
                end
                className={({ isActive }) => {
                    // Profile is active only if base path matches AND tab is NOT schedule
                    if (isActive && !window.location.search.includes('tab=schedule')) return 'nav-item active';
                    return 'nav-item';
                }}
            >
                <div className="icon">👤</div>
                <span>Profile</span>
            </NavLink>
        </nav>
    );
}
